import moment from 'moment'

const formatDateFromNow = date => moment(date).fromNow()

export default formatDateFromNow
